export const translations = {
  it: {
    nav: {
      home: "Home",
      about: "Chi Siamo",
      catalog: "Catalogo",
      contact: "Contatti",
      cta: "Richiedi Informazioni",
    },
    hero: {
      overline: "Made in Italy",
      title1: "Punteria",
      title2: "Bartesaghi",
      tagline: "Qualità e precisione dal 1956",
      sub: "Produzione specializzata di chiodi industriali per la grande distribuzione, ferramenta e clienti professionali.",
      cta: "Esplora il Catalogo",
      ctaSecondary: "Contattaci",
      since: "Dal 1956",
      location: "Valmadrera · Lake Como · Italia",
      logoLabel: "Spazio riservato al logo aziendale",
    },
    stats: {
      years: "Anni di esperienza",
      categories: "Categorie di prodotto",
      madeIn: "Made in Italy",
      b2b: "Solo clientela B2B",
    },
    about: {
      overline: "Chi Siamo",
      title: "Sette decenni di artigianato industriale",
      p1: "La famiglia Bartesaghi produce chiodi dal 1956, con l'esperienza pluridecennale del fondatore nella realizzazione di svariate tipologie di chiodi. La Punteria Bartesaghi s.n.c. nasce come naturale evoluzione di questa tradizione artigianale, portando avanti da due generazioni una passione e un know-how unici nel settore.",
      p2: "Grazie al personale altamente specializzato, siamo in grado di soddisfare le specifiche esigenze di ogni cliente, garantendo un ottimo rapporto qualità/prezzo.",
      pillars: [
        { t: "Esperienza", d: "Oltre settant'anni di know-how nella punteria di precisione." },
        { t: "Specializzazione", d: "Personale altamente qualificato per esigenze specifiche." },
        { t: "Produzione complementare", d: "Produciamo anche attaccaglie snodate, ganci e attaccaglie in tela." },
        { t: "Confezionamento", d: "Disponiamo di impianti di confezionamento in buste PVC termosaldate." },
      ],
      products_intro: "I nostri principali prodotti:",
      products_list: [
        "Chiodi in acciaio",
        "Chiodi in ferro",
        "Chiodi in acciaio con testa ricoperta in ottone",
        "Chiodi in esecuzione speciale",
      ],
    },
    catalog: {
      overline: "Catalogo Prodotti",
      title: "Gamma Completa di Chiodi",
      sub: "Una gamma estesa di chiodi e ganci per ogni applicazione industriale e artigianale.",
      view: "Scopri",
      categories: {
        "chiodi-acciaio": { name: "Chiodi Acciaio", desc: "Per fissaggi ad alta resistenza su calcestruzzo e cemento." },
        "chiodi-ferro": { name: "Chiodi Ferro", desc: "Robusti e versatili, ideali per fissaggi sicuri nel legno e nei lavori di carpenteria." },
        "chiodi-ottone": { name: "Chiodi Ottone", desc: "Estetica raffinata e resistenza alla corrosione." },
        "chiodi-rame": { name: "Chiodi Rame", desc: "Massima resistenza alla corrosione marina e atmosferica. Ideali per la cantieristica navale in legno e coperture di pregio." },
        spilli: { name: "Spilli Senza Testa", desc: "Precisione di fissaggio per lavorazioni delicate." },
        semenze: { name: "Semenza e Sellerine", desc: "Semenze per calzolai e Sellerine brunite per tappezzieri." },
        cambrette: { name: "Cambrette", desc: "Chiodi a U, ideali per il fissaggio di reti, cavi e materiali leggeri su legno in modo stabile e sicuro." },
        fissacavi: { name: "Fissacavi e Ganci", desc: "Soluzioni per il fissaggio di cavi elettrici." },
        cancani: { name: "Chiodi Rullati e Striati", desc: "Soluzione professionale per fissaggi strutturali su legno. Grazie alla rullatura e alla striatura del gambo, offrono una resistenza meccanica superiore e un'aderenza stabile nel tempo." },
        puntine: { name: "Attaccaglie in Tela e Snodate", desc: "Le attaccaglie sono supporti adesivi ad alta tenuta progettati per l'ancoraggio e la sospensione a parete di quadri, stampe e pannelli leggeri senza l'ausilio di viti." },
        "confezioni-self": { name: "Confezioni Self Service", desc: "Ottimizzati per la Distribuzione. Soluzioni espositive pronte per lo scaffale (Shelf-Ready Packaging), progettate per massimizzare la rotazione del prodotto e ridurre i tempi di allestimento nel punto vendita." },
        "acciaio-testa-ricoperta": { name: "Chiodi Acciaio Testa Ricoperta", desc: "Il nostro articolo di punta: chiodi in acciaio con testa ricoperta che uniscono massima resistenza e finitura elegante. La scelta ideale e più amata per il fissaggio a vista di quadri e restauro." },
      },
    },
    pdf: {
      overline: "Catalogo Generale",
      title: "Scarica il catalogo completo in PDF",
      sub: "Tutta la gamma Punteria Bartesaghi in un unico documento. Ideale per distributori e ferramenta.",
      cta: "Scarica PDF",
    },
    contact: {
      overline: "Contatti",
      title: "Siamo a disposizione per quotazioni personalizzate",
      email: "Email",
      phone: "Telefono",
      address: "Sede",
      hours: "Orari",
      addressValue: "Via Roma 93, 23868 Valmadrera (LC) — Italia",
      hoursValue: "Lun – Ven · 08:00 – 18:00",
      writeUs: "Scrivici",
      callUs: "Chiamaci",
    },
    footer: {
      tagline: "Qualità e precisione dal 1956.",
      rights: "Tutti i diritti riservati.",
      address: "Via Roma 93, Valmadrera (LC) — Italia",
      vat: "P.IVA",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      catalog: "Catalog",
      contact: "Contact",
      cta: "Request Info",
    },
    hero: {
      overline: "Made in Italy",
      title1: "Punteria",
      title2: "Bartesaghi",
      tagline: "Quality and precision since 1956",
      sub: "Specialized production of industrial nails for large-scale distribution, hardware retailers and professional clients.",
      cta: "Explore the Catalog",
      ctaSecondary: "Contact us",
      since: "Since 1956",
      location: "Valmadrera · Lake Como · Italy",
      logoLabel: "Company logo space",
    },
    stats: {
      years: "Years of experience",
      categories: "Product categories",
      madeIn: "Made in Italy",
      b2b: "B2B only",
    },
    about: {
      overline: "About Us",
      title: "Seven decades of industrial craftsmanship",
      p1: "The Bartesaghi family has been producing nails since 1956, drawing on the founder's decades of experience in crafting a wide variety of nails. Punteria Bartesaghi s.n.c. emerged as the natural evolution of this artisan tradition, carrying forward two generations of passion and unique know-how in the industry.",
      p2: "Thanks to our highly specialized staff, we are able to meet every client's specific requirements while guaranteeing an excellent quality/price ratio.",
      pillars: [
        { t: "Experience", d: "Over seventy years of know-how in precision tacks." },
        { t: "Specialization", d: "Highly qualified staff for specific needs." },
        { t: "Complementary production", d: "We also produce articulated hangers, hooks and fabric hangers." },
        { t: "Packaging", d: "In-house heat-sealed PVC bag packaging plants." },
      ],
      products_intro: "Our main products:",
      products_list: [
        "Steel nails",
        "Iron nails",
        "Steel nails with brass-coated head",
        "Custom-made nails",
      ],
    },
    catalog: {
      overline: "Product Catalog",
      title: "Full Range of Nails and Products",
      sub: "An extensive range of nails and hooks for every industrial and craft application.",
      view: "Discover",
      categories: {
        "chiodi-acciaio": { name: "Steel Nails", desc: "For high-strength fastening on concrete and cement." },
        "chiodi-ferro": { name: "Iron Nails", desc: "Sturdy and versatile, ideal for secure fastening in wood and carpentry." },
        "chiodi-ottone": { name: "Brass Nails", desc: "Refined aesthetics and corrosion resistance." },
        "chiodi-rame": { name: "Copper Nails", desc: "Maximum resistance to marine and atmospheric corrosion. Ideal for wooden boat building and premium roofing." },
        spilli: { name: "Hardened Steel Pins \"Headless\"", desc: "Precision fastening for delicate work." },
        semenze: { name: "Semenza and Sellerine Nails", desc: "Semenza Polished Nails for shoemakers and Sellerine Blued nails for upholsterers." },
        cambrette: { name: "U-Shaped Nails", desc: "U-shaped nails, ideal for fastening nets, cables and light materials to wood in a stable and secure way." },
        fissacavi: { name: "Cable Clips & Hooks", desc: "Solutions for fastening electrical cables." },
        cancani: { name: "Rolled & Ringed Nails", desc: "Professional solution for structural fastening on wood. Thanks to the rolled and ringed shank, they deliver superior mechanical strength and a stable grip over time." },
        puntine: { name: "Shirtings and Hinged Hooks", desc: "Adhesive high-hold supports designed for anchoring and wall-hanging of frames, prints and light panels without the use of screws." },
        "confezioni-self": { name: "Self-Service Packs", desc: "Optimised for Distribution. Shelf-Ready Packaging solutions designed to maximise product turnover and reduce in-store setup time." },
        "acciaio-testa-ricoperta": { name: "Steel Nails Coated Head", desc: "Our flagship product: steel nails with a coated head combining maximum strength and an elegant finish. The favourite choice for exposed fastening of frames and restoration work." },
      },
    },
    pdf: {
      overline: "General Catalog",
      title: "Download the complete catalog in PDF",
      sub: "The entire Punteria Bartesaghi range in a single document. Ideal for distributors and hardware retailers.",
      cta: "Download PDF",
    },
    contact: {
      overline: "Contact",
      title: "We are available for custom quotations",
      email: "Email",
      phone: "Phone",
      address: "Office",
      hours: "Hours",
      addressValue: "Via Roma 93, 23868 Valmadrera (LC) — Italy",
      hoursValue: "Mon – Fri · 08:00 – 18:00",
      writeUs: "Write us",
      callUs: "Call us",
    },
    footer: {
      tagline: "Quality and precision since 1956.",
      rights: "All rights reserved.",
      address: "Via Roma 93, Valmadrera (LC) — Italy",
      vat: "VAT",
    },
  },
};
